module.exports = __webpack_public_path__ + "img/pay_with_vipps_rect_210_NO.83f1bc05.svg";